<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家')" prop="merchantId">
                <a-select v-model="queryParam.merchantId" :maxLength="32" :placeholder="$t('请选择')+$t('商家')" allow-clear>
                  <a-select-option v-for="item in merchantList" :key="item.id">{{ item.merchantName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('订单编号')" prop="orderId">
                <a-input v-model="queryParam.orderId" :maxLength="32" :placeholder="$t('请输入')+$t('订单编号')" allow-clear/>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('是否匿名评价')" prop="isAnonymous">
                  <a-select v-model="queryParam.isAnonymous" :maxLength="32" :placeholder="$t('请选择')+$t('是否匿名评价')" allow-clear>
                    <a-select-option v-for="item in customDict.TFEnum" :key="item.type">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商品名称')" prop="goodsName">
                <a-input v-model="queryParam.goodsName" :maxLength="32" :placeholder="$t('请输入')+$t('商品名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('评价等级')" prop="explainType">
                <a-select v-model="queryParam.explainType" :maxLength="32" :placeholder="$t('请选择')+$t('评价等级')" allow-clear>
                  <a-select-option v-for="item in customDict.GoodsExplainTypeEnum" :key="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('是否展示')" prop="isShow">
                  <a-select v-model="queryParam.isShow" :maxLength="32" :placeholder="$t('请选择')+$t('是否展示')" allow-clear>
                    <a-select-option v-for="item in customDict.TFEnum" :key="item.type">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('是否置顶')" prop="pushTop">
                  <a-select v-model="queryParam.pushTop" :maxLength="32" :placeholder="$t('请选择')+$t('是否置顶')" allow-clear>
                    <a-select-option v-for="item in customDict.TFEnum" :key="item.type">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.addForm.handleAdd()">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['goods:goodsevaluate:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goodsevaluate:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <add-form ref="addForm" @ok="getList"/>
      <reply-list ref="replyList"/>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="isAnonymous" slot-scope="text, record">
          <custom-dict-tag :options="customDict.TFEnum" :value="record.isAnonymous"/>
        </span>
        <span slot="isShow" slot-scope="text, record">
          <a-switch @change="(checked) => onShowChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isShow"/>
        </span>
        <span slot="pushTop" slot-scope="text, record">
            <a-switch @change="(checked) => onTopChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.pushTop"/>
        </span>
        <span slot="explainType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.GoodsExplainTypeEnum" :value="record.explainType"/>
        </span>
        <template slot="image" slot-scope="text, record">
          <div>
            <img v-if="record.imageList && record.imageList.length>0" :src="record.imageList[0]"  style="width:60px;height:62px;" @click="handleRecordPreview(record.imageList)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a-button size="small" type="link" @click="$refs.replyList.getList(record.id)" >
             <a-icon type="edit" />{{$t('评价列表')}}
          </a-button>
          <a-button size="small" type="link" @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['goods:goodsevaluate:query']">
            <a-icon type="info" />{{$t('详情')}}
          </a-button>
          <a-button size="small" type="link" @click="handleDelete(record)" v-hasPermi="['goods:goodsevaluate:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a-button>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageGoodsEvaluate,goodsEvaluateStatus, delGoodsEvaluate } from '@/api/goods/goodsEvaluate'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import AddForm from './modules/AddForm'
import ReplyList from './modules/ReplyList'
import { tableMixin } from '@/store/table-mixin'
import {listSelectMerchant} from "@/api/merchant/merchantMerchant";
import {updateVisible} from "@/api/goods/category";

export default {
  name: 'GoodsEvaluate',
  components: {
    CustomDictTag,
    CreateForm,
    AddForm,
    ReplyList
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      merchantList:[],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        orderId: undefined,
        goodsId: undefined,
        merchantId: undefined,
        deptId: undefined,
        starNum: undefined,
        userId: undefined,
        userName: undefined,
        isAnonymous: undefined,
        evaluateScore: undefined,
        explainType: undefined,
        isShow: undefined,
        pushTop: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('订单编号'),
          dataIndex: 'orderId',
          align: 'center'
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          align: 'center'
        },
        {
          title: this.$t('商家名称'),
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: this.$t('评价内容'),
          dataIndex: 'content',
          align: 'center'
        },
        {
          title: this.$t('评价图片'),
          dataIndex: 'image',
          scopedSlots: { customRender: 'image' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('评价人名称'),
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('是否匿名评价'),
          scopedSlots: { customRender: 'isAnonymous' },
          dataIndex: 'isAnonymous',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('评价星级'),
          dataIndex: 'evaluateScore',
          align: 'center'
        },
        {
          title: this.$t('评价等级'),
          dataIndex: 'explainType',
          scopedSlots: { customRender: 'explainType' },
          align: 'center'
        },
        {
          title: this.$t('是否展示'),
          dataIndex: 'isShow',
          scopedSlots: { customRender: 'isShow' },
          align: 'center'
        },
        {
          title: this.$t('是否置顶'),
          dataIndex: 'pushTop',
          scopedSlots: { customRender: 'pushTop' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getMerchantList()
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  mounted() {
    this.getRouteList()
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品评价列表 */
    getList () {
      this.loading = true
     pageGoodsEvaluate(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getMerchantList () {
      listSelectMerchant({}).then(response => {
        this.merchantList = response.data
        if (this.userInfo.deptType !== 2) {
          //添加一条记录,放到首位
          this.merchantList.unshift({"id": 0,"merchantName":'平台'})
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        orderId: undefined,
        goodsId: undefined,
        merchantId: undefined,
        deptId: undefined,
        starNum: undefined,
        userId: undefined,
        userName: undefined,
        isAnonymous: undefined,
        evaluateScore: undefined,
        explainType: undefined,
        isShow: undefined,
        pushTop: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    onShowChange(checked, record) {
      let data = {id:record.id, isShow: checked}
      goodsEvaluateStatus(data).then(response => {
        if (response.success) {
          this.$message.success('修改成功', 3);
          this.$emit('ok')
          record.isShow=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onTopChange(checked, record) {
      let data = {id:record.id, pushTop: checked}
      goodsEvaluateStatus(data).then(response => {
        if (response.success) {
          this.$message.success('修改成功', 3);
          this.$emit('ok')
          record.pushTop=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    getRouteList() {
      let query = this.$route.query;
      if (query.orderId) {
        this.queryParam.orderId = query.orderId
      }
      this.getList()
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delGoodsEvaluate(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/goods/goods/evaluate/export',
            that.queryParam
          , `商品评价_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
